import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useIsPrescriber } from '@web-app/hooks/useIsPrescriber';
import type { AppFeatures } from 'growthbook-types/app-features';

/** Enables reminders only for confirmed prescribers with the feature flag on. */
export const useAvailabilityCheckReminderEnabled = (): boolean => {
  const { isPrescriber, isLoading, isError } = useIsPrescriber();
  const featureEnabled = useFeatureIsOn<AppFeatures>(
    GROWTHBOOK_FEATURE_FLAGS.AVAILABILITY_CHECK_REMINDER_ENABLED,
  );

  return featureEnabled && isPrescriber && !isLoading && !isError;
};
